import Layout from '@/layout'
import {
  routerTrans
} from './routeTrans.js'
import _import from './loader.js'
import {
  Message, Badge,
} from 'element-ui'
import Setting from "@/settings"
const {
  dicDomain,
  locatDomain
} = Setting
let constantRoutes = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index'),
    meta: {
      title: 'Dashboard',
      icon: 'dashboard'
    }
  }]
},

{
  path: '/example',
  component: Layout,
  redirect: '/example/table',
  name: 'Example',
  meta: {
    title: 'Example',
    icon: 'example'
  },
  children: [{
    path: 'table',
    name: 'Table',
    component: () => import('@/views/table/index'),
    meta: {
      title: 'Table',
      icon: 'table'
    }
  },
  {
    path: 'tree',
    name: 'Tree',
    component: () => import('@/views/tree/index'),
    meta: {
      title: 'Tree',
      icon: 'tree'
    }
  }
  ]
},
{
  path: '*',
  redirect: '/404',
  hidden: true
}
]
var defaultHome = {
  path: '/',
  component: Layout,
  children: [{
    path: 'dashboard',
    name: '',
    // component: () => import('@/views/dashboard/index'),
    meta: {
      title: '',
      icon: 'dashboard'
    }
  }],
  menuType: 5,
  hidden: false
}

var arr = []
//获取字典列表
arr = [{
  "children": [{
    "children": null,
    "component": "launchList/index",
    "menuType": 4,
    "meta": {
      "icon": "search10_1",
      "title": "流量主区间列表"
    },
    "name": "流量主区间列表",
    "path": "/test",
    "redirect": "",
    "title": "流量主区间列表"
  },],
  "component": "Layout",
  "menuType": 3,
  "meta": {
    "icon": "search10_0",
    "title": "综合查询"
  },
  "name": "综合查询",
  "path": "/launchList",
  "redirect": "Layout",
  "title": "综合查询"
}, {
  "children": [{
    "children": null,
    "component": "billManagement/index",
    "menuType": 4,
    "meta": {
      "icon": "report9_3",
      "title": "数据包金额统计"
    },
    "name": "数据包金额统计",
    "path": "//bill",
    "redirect": "",
    "title": "数据包金额统计"
  }],
  "component": "Layout",
  "menuType": 3,
  "meta": {
    "icon": "report9_0",
    "title": "统计报表"
  },
  "name": "统计报表",
  "path": "/report",
  "redirect": "Layout",
  "title": "统计报表"
}]
var _isNoHome = true
// console.log(JSON.stringify(arr))
arr.forEach((items, idx) => {
  if (items.menuType == 5) {
    _isNoHome = false
    defaultHome.redirect = items.path
    defaultHome.children[0].path = items.path
    defaultHome.children[0].meta.title = items.title
    defaultHome.children[0].component = _import(items.children[0].component)
    arr.splice(idx, 1)
  } else if (items.children.length > 0) {
    items.hidden = false,
      // items.redirect = items.children[0].path
      // items.meta = { title: items.title }
      items.children.forEach(subItem => {
        subItem.path = subItem.path.substr(1)
        // if (subItem.path == 'packetManage/packetModify') {
        // }
        if (subItem.path == "packetManage") {
          subItem.path = '/packetManage'
        }
        // if (subItem.path == 'acketManage/packetModify') {
        //   subItem.path = 'packetManage/packetModify'
        // }
        //数据管理-预估数据核准数据的导航栏隐藏
        if (subItem.path == 'advertiser') {
          items.children = items.children.reverse()
        }
        // if (subItem.path == 'approvalData' || subItem.path == 'estimatedData' || subItem.path == 'bulkImport' || subItem.path == 'dataPacket') {
        //   subItem.hidden = true
        // }
      })
    items.children = items.children.reverse()
    if (items.path == "/search") {
      items.children = items.children.reverse()
    }
  }

})
var baseRoutes = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '/',
  redirect: '/dashboard',
  hidden: true
},
{
  path: '/404',
  component: () => import('@/views/404'),
  hidden: true
}
  // ,
  // {
  //   path: '/custom',
  //   component: Layout,
  //   redirect: '/custom/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/dashboard/index'),
  //       meta: { title: '自定义首页', icon: 'guide', noCache: true }
  //     }
  //   ]
  // }
  , {
  path: '*',
  redirect: '/',
  hidden: true
}
]


const newRoutes = routerTrans(arr)
export function getViews(path) {
  return resolve => require(['@/views/' + path + '.vue'], resolve)
}
baseRoutes.push(defaultHome)
baseRoutes = baseRoutes.concat(newRoutes)
window['baseRoutes'] = baseRoutes
export default baseRoutes
